import { useState, useCallback } from "react";
import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Projects from "@/components/Projects";
import Experience from "@/components/Experience";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ScrollProgress from "@/components/ScrollProgress";
import InteractiveStarfield from "@/components/InteractiveStarfield";
import LoadingScreen from "@/components/LoadingScreen";

const Index = () => {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoadComplete = useCallback(() => {
    setIsLoading(false);
  }, []);

  return (
    <>
      {/* Loading screen overlays on top while components load in background */}
      {isLoading && <LoadingScreen onLoadComplete={handleLoadComplete} />}

      {/* Main content - always mounted for preloading, hidden behind loading screen */}
      <div
        className={`min-h-screen relative transition-opacity duration-700 ease-out ${
          isLoading ? 'opacity-0' : 'opacity-100'
        }`}
        aria-hidden={isLoading}
      >
        <InteractiveStarfield />
        <ScrollProgress />
        <Navigation />
        <main>
          <Hero />
          <Projects />
          <Experience />
          <Contact />
          <About />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Index;
